import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import mdToHtml from "../utils/mdToHtml";

import { Image } from 'components';

const MaintainerTextMedia = ({
  enabled,
  title,
  priceUk,
  priceEn,
  priceSe,
  text,
  image,
  reverse,
  className,
  locale
}) => {
  if(!enabled) return false;

  let localPrice = null;
  switch(locale) {
    case 'uk':
      localPrice = priceUk
      break;
    case 'en':
      localPrice = priceEn
      break;
    case 'se':
      localPrice = priceSe
      break;
    default:
      localPrice = null;
      break;
  }

  let localTitle = title.replace('%%price%%', localPrice);

  return (
    <div className={cx('section-wrapper', { reverse }, [className])}>
      <div className='section-text'>
        <h2 dangerouslySetInnerHTML={{ __html: localTitle }} />
        <div className='mt-20' dangerouslySetInnerHTML={{ __html: mdToHtml(text) }} />
      </div>
      <div className='section-media'>
        <Image url={image.url} alt={image.alt} />
      </div>
    </div>
  );
};

MaintainerTextMedia.propTypes = {
  title: PropTypes.string.isRequired,
  priceUk: PropTypes.string,
  priceEn: PropTypes.string,
  priceSe: PropTypes.string,
  text: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    noBlur: PropTypes.bool,
  }).isRequired,
  reverse: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

MaintainerTextMedia.defaultProps = {
  reverse: false,
  className: '',
};

export default MaintainerTextMedia;
